import {Component, OnInit} from '@angular/core';
// import {Breadcrumb, PpBreadcrumbsService} from 'pp-breadcrumbs';
import {Router} from "@angular/router";

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class LocalBreadcrumbComponent implements OnInit {
    crumbs: any[];

    constructor(
        // private breadcrumbsService: PpBreadcrumbsService,
        private router: Router
    ) {
    }


    ngOnInit(): void {
        // this.breadcrumbsService.crumbs$.subscribe((crumbs) => {
        //     console.log(crumbs)
        //     this.crumbs = crumbs;
        // });
    }

    navigate(path) {
        this.router.navigate([path])
    }
}
